var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("PortfolioNavigation", {
        attrs: { workspaceId: _vm.workspaceId, projectId: _vm.tchProjectId },
      }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container-fluid",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [_vm._v(_vm._s(_vm.rm.ProjectName))]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 text-right align-self-end" },
                  [
                    _vm.isEditing
                      ? _c("SaveButton", {
                          attrs: { savingState: _vm.savingState },
                          on: {
                            saveChanges: function ($event) {
                              return _vm.handleSaveCommand()
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isEditing
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            staticStyle: { padding: "0.7em 2em" },
                            on: { click: _vm.cancelEditing },
                          },
                          [_vm._v(_vm._s(_vm.stopEditingLabel))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isEditing && !_vm.isSubmitted
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-success",
                            staticStyle: { padding: "0.7em 2em" },
                            on: { click: _vm.startEditing },
                          },
                          [
                            _vm._v(
                              "\n                    Edit savings\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isEditing && _vm.isSubmitted
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            staticStyle: {
                              padding: "0.7em 2em",
                              cursor: "default",
                            },
                            attrs: {
                              disabled: "",
                              title: "You cannot edit a submitted plan",
                            },
                          },
                          [
                            _c("i", { staticClass: "fas fa-lock mr-2" }),
                            _vm._v(" Submitted\n                "),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isEditing
                      ? _c(
                          "a",
                          {
                            directives: [
                              {
                                name: "sanitizedHref",
                                rawName: "v-sanitizedHref",
                                value: `/#/portfolio/alternative/dashboard/${_vm.rm.WorkspaceId}/${_vm.rm.TchProjectId}/${_vm.rm.ProjectId}`,
                                expression:
                                  "`/#/portfolio/alternative/dashboard/${rm.WorkspaceId}/${rm.TchProjectId}/${rm.ProjectId}`",
                              },
                            ],
                            staticClass: "btn btn-outline-secondary",
                            staticStyle: { padding: "0.7em 2em" },
                          },
                          [_vm._v("Meta data")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("ProjectNavigation", {
                staticClass: "mt-4",
                attrs: {
                  ActivePage: "resources",
                  workspaceId: _vm.workspaceId,
                  tchProjectId: _vm.tchProjectId,
                  projectId: _vm.projectId,
                  planId: _vm.rm.ProjectPlanId,
                },
              }),
              _vm._v(" "),
              _vm.isEditing
                ? _c(
                    "div",
                    [
                      _c("div", { staticClass: "form-group mb-4" }, [
                        _c(
                          "label",
                          {
                            staticClass: "mb-1 text-muted",
                            staticStyle: {
                              "font-weight": "400",
                              "font-size": "0.97em",
                            },
                            attrs: { for: "comment" },
                          },
                          [
                            _vm._v(
                              "\n                    Assumptions or notes (optional)\n                "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model.trim",
                              value: _vm.editingComment,
                              expression: "editingComment",
                              modifiers: { trim: true },
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { id: "comment", rows: "3" },
                          domProps: { value: _vm.editingComment },
                          on: {
                            input: [
                              function ($event) {
                                if ($event.target.composing) return
                                _vm.editingComment = $event.target.value.trim()
                              },
                              _vm.onDataChange,
                            ],
                            blur: function ($event) {
                              return _vm.$forceUpdate()
                            },
                          },
                        }),
                      ]),
                      _vm._v(" "),
                      _vm._m(0),
                      _vm._v(" "),
                      _c("EditableValueSeriesSheet", {
                        ref: "sheet",
                        attrs: {
                          propTitle: _vm.rm.Title,
                          propSeries: _vm.inputSeries,
                          propColumns: _vm.rm.Columns,
                        },
                        on: { dataChange: _vm.onDataChange },
                      }),
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c("div", { staticClass: "toolbar" }, [
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticClass: "btn-group",
                              attrs: { role: "group" },
                            },
                            [
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "sanitizedHref",
                                      rawName: "v-sanitizedHref",
                                      value: `/#/q/project/resource-allocations/${_vm.rm.WorkspaceId}/${_vm.rm.TchProjectId}/${_vm.rm.ProjectId}/${_vm.rm.ProjectPlanId}`,
                                      expression:
                                        "`/#/q/project/resource-allocations/${rm.WorkspaceId}/${rm.TchProjectId}/${rm.ProjectId}/${rm.ProjectPlanId}`",
                                    },
                                  ],
                                  staticClass: "btn btn-outline-secondary",
                                },
                                [
                                  _vm._v(
                                    "\n                            Allocations\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "btn btn-secondary disabled" },
                                [
                                  _vm._v(
                                    "\n                            Savings\n                        "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "a",
                                {
                                  directives: [
                                    {
                                      name: "sanitizedHref",
                                      rawName: "v-sanitizedHref",
                                      value: `/#/q/project/resource-costs/${_vm.rm.WorkspaceId}/${_vm.rm.TchProjectId}/${_vm.rm.ProjectId}/${_vm.rm.ProjectPlanId}`,
                                      expression:
                                        "`/#/q/project/resource-costs/${rm.WorkspaceId}/${rm.TchProjectId}/${rm.ProjectId}/${rm.ProjectPlanId}`",
                                    },
                                  ],
                                  staticClass: "btn btn-outline-secondary",
                                },
                                [
                                  _vm._v(
                                    "\n                            Unit costs\n                        "
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div"),
                      ]),
                      _vm._v(" "),
                      _vm.comment
                        ? _c(
                            "div",
                            {
                              staticClass: "alert alert-info mt-3 mb-3",
                              staticStyle: { "white-space": "pre-line" },
                            },
                            [
                              _c("strong", [_vm._v("Assumptions / Notes:")]),
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.comment) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("ValueSeriesTable", {
                        attrs: {
                          propTitle: _vm.rm.Title,
                          propSeries: _vm.rm.Series,
                          propColumns: _vm.rm.Columns,
                          propStartDate: _vm.rm.ProjectStartDate,
                        },
                      }),
                    ],
                    1
                  ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "alert alert-warning mb-1" }, [
      _c("strong", [_vm._v("Note:")]),
      _vm._v(
        "Please enter savings as a positive number. Formula entered below will save as values.\n            "
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }